import { cn } from "@/lib/utils";

const MAP = {
    "Normal": "text-volt border-volt/40 bg-volt/5",
    "Likely Human": "text-volt border-volt/40 bg-volt/5",
    "Needs Review": "text-warn border-warn/40 bg-warn/10",
    "Unknown": "text-warn border-warn/40 bg-warn/10",
    "Likely Bot": "text-alert border-alert/40 bg-alert/10",
    "Highly Unusual": "text-alert border-alert/40 bg-alert/10",
    "Victory": "text-success border-success/40 bg-success/10",
    "Defeat": "text-muted-foreground border-border bg-secondary",
    "Unverified": "text-warn border-warn/40 bg-warn/10",
    "Pro": "text-success border-success/40 bg-success/10",
    "Owner": "text-volt border-volt/40 bg-volt/10",
    "Free": "text-muted-foreground border-border bg-secondary",
};

export function StatusBadge({ status, className }) {
    const style = MAP[status] || "text-muted-foreground border-border bg-secondary";
    return (
        <span
            data-testid={`status-badge-${String(status).toLowerCase().replace(/\s+/g, "-")}`}
            className={cn(
                "inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-sm border text-[11px] font-mono uppercase tracking-wider whitespace-nowrap",
                style,
                className
            )}
        >
            {status}
        </span>
    );
}
